// カート追加を押した時の処理
const addButtons = document.querySelectorAll('.item-select__add');
addButtons.forEach((item) => {
  item.addEventListener('click', () => {
    const variantId = item.getAttribute('data-id');
    handleAddToCart(variantId);
  });
});

// 再入荷通知を押した時の処理
const backInStockBtns = document.querySelectorAll('.item-select__notification.backInStock');
const showVariants = document.querySelector('#show-variants');

backInStockBtns.forEach((item) => {
  item.addEventListener('click', () => {
    // BackInStockのiframeを取得
    const variantsSelect = document
      .querySelector('#BIS_frame')
      .contentDocument.getElementById('variants');
    const variantId = item.getAttribute('data-variant-id');
    if (showVariants.value) {
      const showVariantsIds = showVariants.value.split(',');
      // showVariantsIdsの中に含まれていないoptionを削除する
      variantsSelect.querySelectorAll('option').forEach((option) => {
        if (!showVariantsIds.includes(option.value)) {
          option.remove();
        }
      });
    }
    handleBackInStock(variantId);
  });
});

// モーダル表示・非表示
const cartModal = document.querySelector('.item-select-modal');
const modalTriggers = document.querySelectorAll(
  '.item-select-modal__overlay, .item-select-modal__close, .item-select-modal__bottom-close, .product-form__buttons'
);

const animationDuration = 500;

modalTriggers.forEach((trigger) => {
  trigger.addEventListener('click', () => {
    console.log('click');
    if (cartModal.classList.contains('is-show')) {
      // モーダルを非表示にする場合ß
      cartModal.animate([{ opacity: '1' }, { opacity: '0' }], {
        duration: animationDuration,
        easing: 'ease-in-out',
        fill: 'forwards',
      }).onfinish = () => {
        cartModal.style.display = 'none';
        cartModal.classList.toggle('is-show');
      };
    } else {
      // モーダルを表示する場合
      // cartModal.style.opacity = 0;
      cartModal.style.display = 'block';
      cartModal.classList.toggle('is-show');
      cartModal.animate([{ opacity: '0' }, { opacity: '1' }], {
        duration: animationDuration,
        easing: 'ease-in-out',
        fill: 'forwards',
      });
    }
  });
});

// カートに追加し、カート画面へ遷移
const cartAdd = async (variantId) => {
  const formData = {
    items: [
      {
        quantity: 1,
        id: variantId,
      },
    ],
  };

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      dataType: 'json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((res) => {
      if (res.ok) {
        window.location = '/cart';
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};
/* SP版カートをワンスクロール後に表示*/
window.addEventListener('DOMContentLoaded', function () {
  let lastScrollTop = 0; // 最後のスクロール位置を保持

  // 要素の取得
  const hiddenBorderTopElement = document.querySelector('.product__addToCart__top');
  const hiddenBorderBottomElement = document.querySelector('.product__addToCart__bottom');

  // 要素の位置を更新する関数
  function updatePositions() {
    return {
      top:
        hiddenBorderTopElement.getBoundingClientRect().top +
        window.pageYOffset -
        window.innerHeight +
        130,
      bottom:
        hiddenBorderBottomElement.getBoundingClientRect().top +
        window.pageYOffset -
        window.innerHeight,
    };
  }

  let positions = updatePositions(); // 初期位置の取得

  var scrollElements = document.querySelectorAll('.item-select-sp');

  function handleScroll() {
    const currentPosition = window.pageYOffset || document.documentElement.scrollTop;
    positions = updatePositions(); // スクロールのたびに位置を更新

    const isScrollingDown = currentPosition > lastScrollTop;

    if (isScrollingDown) {
      // 上の要素の下端がビューポートから消える（上の要素が完全に表示されている）までは非表示
      if (currentPosition <= positions.top) {
        scrollElements.forEach((el) => el.classList.remove('show'));
      }
      // 上の要素の下端がビューポートから消えた瞬間から、下の要素の上端がビューポートに入るまで表示
      else if (currentPosition > positions.top && currentPosition < positions.bottom) {
        scrollElements.forEach((el) => el.classList.add('show'));
      }
      // 下の要素の上端がビューポートに入ったら非表示
      else {
        scrollElements.forEach((el) => el.classList.remove('show'));
      }
    } else {
      // 上にスクロールしている場合は非表示にする
      scrollElements.forEach((el) => el.classList.remove('show'));
    }

    // 下の要素がビューポート内に完全に入ったら非表示
    if (currentPosition > positions.bottom) {
      scrollElements.forEach((el) => el.classList.remove('show'));
    }

    lastScrollTop = currentPosition; // スクロール位置を更新
  }

  window.addEventListener('scroll', handleScroll);
});

function handleAddToCart(variantId) {
  const cartItemType = cartItemsCheck();
  const productType = productTypeCheck();
  if (checkUnableToAdd()) {
    cartAdd(variantId);
  } else {
    alert(alertMessageSwitch(productType, cartItemType));
    return;
  }
}

const currentCartItemTags = JSON.parse(document.querySelector('[data-cart-item-tags]').innerText);
const productTags = JSON.parse(document.querySelector('[data-tags]').innerText);
const checkUnableToAdd = () => {
  const productType = productTypeCheck();
  const cartItemsType = cartItemsCheck();
  console.log('productType', productType);
  console.log('cartItemsType', cartItemsType);
  
  // カートに何も入っていない場合は追加可能
  if (currentCartItemTags.length === 0) {
    return true;
  }

  // カート内の商品が同じタイプの場合は追加可能
  if (productType === cartItemsType) {
    return true;
  }

  // BeforeCare商品の場合は追加可能
  if (productType === 'BEFORE_CARE') {
    return true;
  }

  // FOODタグを持つ商品がカートにある場合
  if (cartItemsType === 'FOOD') {
    // カート内にwrappingタグがあるかどうかをチェック
    const hasWrappingTag = currentCartItemTags.includes('wrapping');
    const hasFoodTag = currentCartItemTags.includes('FOOD');

    // wrappingタグとFOODタグの両方がある場合のみtrueを返す
    if (hasWrappingTag && hasFoodTag) {
      return true;
    } else {
      return false;
    }
  }


  // その他の条件は追加不可
  return false;
};


const productTypeCheck = () => {
  if (productTags.includes('BEFORE_CARE')) {
    return 'BEFORE_CARE';
  }
  if (productTags.includes('BRIDAL')) {
    return 'BRIDAL';
  }
  if (productTags.includes('FOOD')) {
    return 'FOOD';
  }
  if (productTags.includes('SAMPLERING')) {
    return 'SAMPLERING';
  }
  if (productTags.includes('予約商品')) {
    return 'RESERVATION';
  }
  return 'NORMAL';
};

const cartItemsCheck = () => {
  if (currentCartItemTags.includes('BRIDAL')) {
    return 'BRIDAL';
  }
  if (currentCartItemTags.includes('FOOD')) {
    return 'FOOD';
  }
  if (currentCartItemTags.includes('wrapping')) {
    return 'wrapping';
  }
  if (currentCartItemTags.includes('SAMPLERING')) {
    return 'SAMPLERING';
  }
  if (currentCartItemTags.includes('予約商品')) {
    return 'RESERVATION';
  }
  return 'NORMAL';
};

const alertMessageSwitch = (productType, cartItemType) => {
  console.log('productType', productType);
  if (cartItemType === 'NORMAL' && productType === 'RESERVATION') {
    return 'ご予約商品と通常商品は発送日がことなるため同時に購入いただけません。\n恐れ入りますが、個別にご注文ください。';
  }
  if (cartItemType === 'RESERVATION' && productType === 'NORMAL') {
    return 'ご予約商品と通常商品は発送日がことなるため同時に購入いただけません。\n恐れ入りますが、カートをご確認いただき、購入を完了するか、商品の削除をお願いします。';
  }
  if (cartItemType === 'NORMAL' && productType !== 'NORMAL') {
    return '通常商品と食品・サンプルリング・ブライダル商品は同時に購入いただけません。\n恐れ入りますが、カートをご確認いただき、購入を完了するか、商品の削除をお願いします。';
  }
  if (cartItemType !== 'NORMAL' && productType === 'NORMAL') {
    return 'カートの食品・サンプルリング・ブライダル商品と通常商品は同時に購入いただけません。\n恐れ入りますが、カートをご確認いただき、購入を完了するか、商品の削除をお願いします。';
  }
  return '同時に購入いただけない商品がカート内に含まれています。\n恐れ入りますが、カートをご確認いただき、購入を完了するか、商品の削除をお願いします。';
};

/**
 * 再入荷通知のポップアップ表示
 * @param {string} variantId
 */
const handleBackInStock = (variantId) => {
  if (BIS) {
    BIS.popup.show({ variantId });
  }
};
